import React, { useEffect, useState } from "react";
import { Modal, ModalFooter, ModalHeader, ModalBody, UncontrolledTooltip } from "reactstrap";
import { toast } from "react-toastify";
import { Trash } from "react-feather";
import { fetchPiAsignable, createWatcher } from "../../services/ticketingServices";
import { StyledSelect } from "../../components/StyledSelect";
import SpinnerButton from "../../components/Button";
import useFetcher from "../../hooks/useFetcher";

function WatchersModal({ toggle, isOpen, ticketId, watchers, loadTicket, piAsignableOptions, isAdmin }) {
  const [piAsignable, isLoadingPis] = useFetcher(fetchPiAsignable, undefined, "piAsignable");
  const [watcher, setWatcher] = useState(null);
  const [watchersList, setWatchersList] = useState([]);

  useEffect(() => {
    if (!watchers) return;
    const formattedWatchers = watchers.map((w) => ({ label: w.nombreApellido, value: w.itemId }));
    setWatchersList(formattedWatchers);
  }, [watchers]);

  const piAsignableOptionsForAdmin = piAsignable
    ? piAsignable
        .map((item) => {
          return { label: item.nombreApellido, value: item.itemId };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  // Si es admin, se muestran todos los pis
  const pisAsignables = isAdmin ? piAsignableOptionsForAdmin : piAsignableOptions;
  // Elimina los pis que ya estan en la lista de watchers
  const filteredOptions = pisAsignables.filter((item) => !watchersList.some((w) => w.value === item.value));

  const handleSelectChange = (selected) => {
    setWatcher(selected);
  };

  const handleAddWatcher = () => {
    const newWatchersList = [...watchersList];
    newWatchersList.push(watcher);
    setWatchersList(newWatchersList);
    setWatcher(null);
  };

  const handleSaveWatchers = async () => {
    const watchersIds = watchersList.map((item) => item.value);
    try {
      await createWatcher(ticketId, { watchers: [...watchersIds] });

      toast.success("Watchers guardados");
    } catch (error) {
      toast.error("Error al agregar watcher");
    }
    loadTicket();
    toggle();
  };

  const handleDeleteWatcher = (watcherId) => {
    const newWatchersList = watchersList.filter((w) => w.value !== watcherId);
    setWatchersList(newWatchersList);
  };

  return (
    <Modal centered backdrop="static" isOpen={isOpen} toggle={toggle} size="lg">
      <div>
        <ModalHeader className="border-0 pb-0" toggle={toggle} />
        <form style={{ width: "80%", margin: "0 auto" }}>
          <ModalBody>
            <div className="d-flex justify-content-between align-items-center w-100">
              <StyledSelect
                className="w-100 mr-3"
                name="watcherSelected"
                options={filteredOptions}
                onChange={(selected) => handleSelectChange(selected)}
                value={watcher}
                isLoading={isAdmin && isLoadingPis}
              />

              <button disabled={!watcher || watchersList.length >= 5} type="button" className="btn btn-primary" style={{ height: "35px" }} onClick={handleAddWatcher}>
                Agregar
              </button>
            </div>

            <h4 className="mt-4 mb-2 w-100 text-start">Lista de Watchers:</h4>
            {watchersList.length > 0 ? (
              <div className="text-center border rounded w-100 p-10 bold mt-2 mb-4">
                {watchersList.map((e) => {
                  return (
                    <div className="d-flex justify-content-between border-bottom my-2" style={{ padding: "0 10px" }}>
                      {e.label}
                      <div>
                        <UncontrolledTooltip target={`deleteWatcher${e.value}`}>Eliminar watcher</UncontrolledTooltip>
                        <Trash id={`deleteWatcher${e.value}`} size={20} onClick={() => handleDeleteWatcher(e.value)} style={{ cursor: "pointer" }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center border rounded w-100 p-10 bold mt-2 mb-4">No hay Watchers asignados en este ticket</div>
            )}
          </ModalBody>
          <ModalFooter className="border-0 pt-0">
            <div className="mb-0 w-100 d-flex justify-content-end">
              <SpinnerButton className="btn btn-light mr-2" type="button" onClick={toggle}>
                Cerrar
              </SpinnerButton>
              <SpinnerButton color="btn btn-primary" disabled={watchers.length === 0 && watchersList.length === 0} onClick={handleSaveWatchers} type="button">
                Guardar cambios
              </SpinnerButton>
            </div>
          </ModalFooter>
        </form>
      </div>
    </Modal>
  );
}

export default WatchersModal;
